import React from 'react'

import {
    Grid,
    Button,
    Dialog,
    DialogContent,
    useTheme,
    useMediaQuery
} from "@material-ui/core";
import DynamicInput from '../InputComponents/DynamicInput';
const EditModalPosition = ({ EditpositionModal }) => {

    let { employeeDetails, open, close, submitForm, updateCompCode, updatepayCode, positionEdit, changePositionEdit, listData } = EditpositionModal;

    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    let fields = [
        { type: 1, name: "Employee ID", initial: employeeDetails?.id, isDisabled: true },
        { type: 1, name: "Full Title", initial: positionEdit?.fullTitle, onChange: (value) => changePositionEdit({ ...positionEdit, fullTitle: value }) },
        { type: 3, key: 'title', options: listData?.sites, name: "Location", initial: positionEdit?.locationObj, onChange: (newValue) => changePositionEdit({ ...positionEdit, locationObj: { id: newValue?.id, title: newValue?.title } }) },
        { type: 3, key: 'name', options: listData?.level, name: "Position Category", initial: positionEdit?.positionObj, onChange: (newValue) => changePositionEdit({ ...positionEdit, positionObj: { id: newValue?.id, name: newValue?.name } }) },
        { type: 1, name: "Accounting Job Code", initial: positionEdit?.jobCode, onChange: (value) => changePositionEdit({ ...positionEdit, jobCode: value }) },
        { type: 3, key: 'name', options: updatepayCode, name: "Pay Code", initial: positionEdit?.payCode, onChange: (newValue) => changePositionEdit({ ...positionEdit, payCode: { id: newValue?.id, name: newValue?.name } }) },
        { type: 3, key: 'name', options: updateCompCode, name: "Comp Code", initial: positionEdit?.compCode, onChange: (newValue) => { changePositionEdit({ ...positionEdit, compCode: { id: newValue?.id, name: newValue?.name } }) } },
        { type: 3, key: 'title', options: listData?.departments, name: "Sub Department", initial: positionEdit?.subDepartmentObj, onChange: (newValue) => changePositionEdit({ ...positionEdit, subDepartmentObj: { id: newValue?.id, title: newValue?.title } }) },
        { type: 3, key: 'name', options: listData?.users, name: "Supervisor", initial: positionEdit?.supervisorObj, onChange: (newValue) => changePositionEdit({ ...positionEdit, supervisorObj: { id: newValue?.id, name: newValue?.name } }) },
        { type: 2, name: "Start Date", initial: positionEdit?.startDate, onChange: (value) => changePositionEdit({ ...positionEdit, startDate: value }) },
    ]


    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={close}
            className="BroadcastMessageModal LiqTables"
            aria-labelledby="responsive-dialog-title"
        >
            <Button autoFocus onClick={close} className="ModalClose">
            </Button>
            <form onSubmit={submitForm}>
                <h3>Edit Position</h3>
                <DialogContent>
                    <DynamicInput fields={fields} />
                    <Grid xs={12} container justify="center" className="mt30">
                        <Button type="submit" className="LinkButton">Save</Button>
                    </Grid>
                </DialogContent>
            </form>
        </Dialog>
    )
}

export default EditModalPosition


